module.exports = __webpack_public_path__ + "7c453950e7b04f95485504f707dd586c.svg";